import React from 'react';
import { Percent, ThumbsUp, HeartHandshake, Shield, Clock, BadgeCheck } from 'lucide-react';

export function WhyChooseUs() {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-4">
          Danmarks Mest Omfattende Forsikringstjek
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Find billig forsikring der matcher dine behov. Vores certificerede rådgivere sammenligner 
          priser og dækning fra Danmarks førende forsikringsselskaber og finder de bedste tilbud til dig.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 stagger-children">
          <article className="text-center hover-card p-6 rounded-xl">
            <div className="bg-green-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-transform duration-300 hover:rotate-12">
              <Percent className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Spar op til 30% på forsikringer</h3>
            <p className="text-gray-600">
              Vores kunder sparer i gennemsnit 2.500 kr årligt på deres forsikringer gennem vores gratis forsikringstjek
            </p>
          </article>
          
          <article className="text-center hover-card p-6 rounded-xl">
            <div className="bg-green-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-transform duration-300 hover:rotate-12">
              <ThumbsUp className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="text-xl font-semibold mb-2">97% kundetilfredshed</h3>
            <p className="text-gray-600">
              Tusindvis af danskere har fundet billigere forsikring gennem vores uafhængige forsikringstjek
            </p>
          </article>
          
          <article className="text-center hover-card p-6 rounded-xl">
            <div className="bg-green-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-transform duration-300 hover:rotate-12">
              <HeartHandshake className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Uafhængig rådgivning</h3>
            <p className="text-gray-600">
              Sammenlign forsikring fra alle store selskaber og få den bedste pris - helt uforpligtende
            </p>
          </article>
        </div>

        <div className="mt-16 bg-green-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-center mb-6">Sådan finder du billig forsikring</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="flex flex-col items-center">
              <div className="text-2xl font-bold text-green-600 mb-2">1</div>
              <h4 className="text-lg font-semibold mb-2">Vælg forsikringer</h4>
              <p className="text-center text-gray-600">Start dit gratis forsikringstjek ved at vælge dine forsikringer</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-2xl font-bold text-green-600 mb-2">2</div>
              <h4 className="text-lg font-semibold mb-2">Udfyld information</h4>
              <p className="text-center text-gray-600">Del dine behov så vi kan finde de bedste tilbud til dig</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-2xl font-bold text-green-600 mb-2">3</div>
              <h4 className="text-lg font-semibold mb-2">Modtag tilbud</h4>
              <p className="text-center text-gray-600">Få personlige forsikringstilbud inden for 24 timer</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-2xl font-bold text-green-600 mb-2">4</div>
              <h4 className="text-lg font-semibold mb-2">Spar penge</h4>
              <p className="text-center text-gray-600">Vælg det bedste tilbud og reducer dine forsikringsudgifter</p>
            </div>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <article className="bg-white p-8 rounded-xl shadow-lg">
            <h3 className="text-2xl font-bold mb-6">Hvorfor vælge vores forsikringstjek?</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Shield className="w-6 h-6 text-green-600 mt-1 mr-3" />
                <div>
                  <h4 className="font-semibold mb-1">Dokumenteret besparelse</h4>
                  <p className="text-gray-600">Vi finder i gennemsnit 2.500 kr i årlig besparelse på dine forsikringer</p>
                </div>
              </li>
              <li className="flex items-start">
                <Clock className="w-6 h-6 text-green-600 mt-1 mr-3" />
                <div>
                  <h4 className="font-semibold mb-1">Hurtig proces</h4>
                  <p className="text-gray-600">Få svar på dit forsikringstjek inden for 24 timer</p>
                </div>
              </li>
              <li className="flex items-start">
                <BadgeCheck className="w-6 h-6 text-green-600 mt-1 mr-3" />
                <div>
                  <h4 className="font-semibold mb-1">Certificerede eksperter</h4>
                  <p className="text-gray-600">Få rådgivning fra certificerede forsikringseksperter med mange års erfaring</p>
                </div>
              </li>
            </ul>
          </article>
          <article className="bg-white p-8 rounded-xl shadow-lg">
            <h3 className="text-2xl font-bold mb-6">Populære forsikringer at sammenligne</h3>
            <ul className="space-y-4">
              <li className="flex items-center justify-between">
                <span className="font-semibold">Bilforsikring</span>
                <span className="text-green-600">Spar op til 30%</span>
              </li>
              <li className="flex items-center justify-between">
                <span className="font-semibold">Husforsikring</span>
                <span className="text-green-600">Spar op til 25%</span>
              </li>
              <li className="flex items-center justify-between">
                <span className="font-semibold">Indboforsikring</span>
                <span className="text-green-600">Spar op til 20%</span>
              </li>
              <li className="flex items-center justify-between">
                <span className="font-semibold">Ulykkesforsikring</span>
                <span className="text-green-600">Spar op til 15%</span>
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}